// src/features/policies/modals/CreateVersionModal.jsx

import React, { useEffect, useState } from "react";

import PolicyForm from "../components/PolicyForm";

import {
  createPolicyVersion,
  getPolicyVersions
} from "../api/policyApi";

import { emptyPolicy } from "../types/policy";

export default function CreateVersionModal({
  policyId,
  apiKey,
  tenantId,
  onClose,
  onSaved
}) {

  const [policy, setPolicy] = useState(
    emptyPolicy()
  );

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  useEffect(() => {

    async function loadLatestVersion() {

      setLoading(true);

      setError("");

      try {

        const response =
          await getPolicyVersions(
            apiKey,
            tenantId,
            policyId,
            0,
            1
          );

        if (
          response.content &&
          response.content.length > 0
        ) {

          const latest =
            response.content[0];

          setPolicy({

            policyName:
              latest.policyName,

            policyDescription:
              latest.policyDescription,

            priority:
              latest.priority,

            effect:
              latest.effect,

            effectiveFrom:
              latest.effectiveFrom,

            effectiveTo:
              latest.effectiveTo,

            roles:
              latest.roles || [],

            actions:
              latest.actions || [],

            resourceScope: {

                resourceType:
                    latest.resourceScope?.resourceType ||
                    "SCHEMA",

                resourceName:
                    latest.resourceScope?.resourceName ||
                    "",

                classification:
                    latest.resourceScope?.classification ||
                    "PUBLIC",

                filters:
                    latest.resourceScope?.filters || []
            },

          conditions:
              latest.conditions?.map(c => ({
                  type: c.type,
                  operator: c.operator,
                  value: c.value
              })) || []
          });
        }

      } catch (e) {

        setError(e.message);

      } finally {

        setLoading(false);

      }
    }

    loadLatestVersion();

  }, [
    apiKey,
    tenantId,
    policyId
  ]);

  async function handleSave() {

    setLoading(true);

    setError("");

    try {

      await createPolicyVersion(
        apiKey,
        tenantId,
        policyId,
        policy
      );

      onSaved();

      onClose();

    } catch (e) {

      setError(e.message);

    } finally {

      setLoading(false);

    }
  }

  return (

    <div className="modal-overlay">

     <div className="modal-content modal-lg">

        <div className="modal-title">
          Create New Version
        </div>

        <div className="modal-subtitle">
          Create a new version based on the latest policy configuration
        </div>

        {error && (
          <div className="policy-error">
            {error}
          </div>
        )}

        <PolicyForm
          policy={policy}
          onChange={setPolicy}
          readOnlyName
        />

        <div className="modal-actions">

          <button
            className="btn btn-primary"
            disabled={loading}
            onClick={handleSave}
          >

            {loading
              ? "Creating..."
              : "Create Version"}

          </button>

          <button
            className="btn btn-secondary"
            onClick={onClose}
          >
            Cancel
          </button>

        </div>

      </div>

    </div>
  );
}